var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progress" }, [
    _c("div", {
      staticClass: "progress-bar bg-warning",
      style: "width: " + (_vm.facture / _vm.total) * 100 + "%",
      attrs: { role: "progressbar" },
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "progress-bar bg-primary",
      style: "width: " + (_vm.paye / _vm.total) * 100 + "%",
      attrs: { role: "progressbar" },
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "progress-bar bg-success",
      style: "width: " + (_vm.reverse / _vm.total) * 100 + "%",
      attrs: { role: "progressbar" },
    }),
    _vm._v(" "),
    _c("div", {
      staticClass: "progress-bar",
      staticStyle: { "background-color": "#d4d4d4" },
      style: "width: " + (_vm.non_facture / _vm.total) * 100 + "%",
      attrs: { role: "progressbar" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }